<template>
  <div class="pt-2 about">
   <main v-if="getSelectedCar" role="main">

      <section class="jumbotron text-center">
        <div class="container">
          <!-- {{baseURL}} -->
          <img :src="imageBaseURL +  'img/cars/' + getSelectedCar.refnum + '/car01.jpg'" :alt="getSelectedCar.make + ' ' + getSelectedCar.model + ' £' + getSelectedCar.price" class="img img-thumbnail">
          <h5 :v-if="getSelectedCar.name" class="jumbotron-heading pt-3">{{ getSelectedCar.name }}</h5>
          <p class="text-muted" v-html="getSelectedCar.smalldesc"></p>
          <!-- <h6 v-html="car.extra"></h6> -->
          <!-- <h2 class="text-right">£ {{car.price}}</h2> -->
              <table class="table table-sm table-striped pt-2">
                <!-- <thead>
                  <tr>
                    <th scope="col">First</th>
                    <th scope="col">Last</th>
                    <th scope="col">Handle</th>
                  </tr>
                </thead> -->
                <tbody>
                  <tr>
                    <td>Make</td>
                    <td>{{getSelectedCar.make}}</td>
                  </tr>
                  <tr>
                    <td>Model</td>
                    <td>{{getSelectedCar.model}}</td>
                  </tr>
                  <tr>
                    <td>Year</td>
                    <td>{{getSelectedCar.year}}</td>
                  </tr>
                  <tr>
                    <td>Mileage</td>
                    <td>{{getSelectedCar.mileage}}</td>
                  </tr>
                  <!-- <tr>
                    <td>Price</td>
                    <td v-if="getSelectedCar.soldStaus">£ {{getSelectedCar.price}} <div v-if="getSelectedCar.soldStaus" style="background-color:red;color:white;">SOLD</div> </td>
                  </tr> -->
                  <tr v-if="getSelectedCar.soldStaus">
                    <td style="background-color:#df2222;color:white;">SOLD</td>
                    <td style="background-color:#df2222;color:white;"> {{getSelectedCar.price}} </td>
                  </tr>
                  <tr v-else>
                    <td><strong>Price</strong></td>
                    <td v-if="getSelectedCar.price"><strong>£ {{getSelectedCar.price}} </strong></td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-left pt-4"><h5>Description</h5>
                    <div class="text-left" v-html="getSelectedCar.largedesc"></div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="getSelectedCar.extra !== ''" class="card">
                <h5 class="text-left p-3" >Notes</h5 >
                <div class="text-left pl-3 pb-2" v-html="getSelectedCar.extra"></div>
              </div>
          <!-- <p>
            <a href="#" class="btn btn-primary my-2">Main call to action</a>
            <a href="#" class="btn btn-secondary my-2">Secondary action</a>
          </p> -->
        </div>
      </section>

      <div class="album py-5 bg-light">
        <div class="container">
          <!-- <div v-for="(item, index) in carImages" :key="index">
            {{ item.name }}
          </div> -->

          <div v-if="getSelectedCar" class="row">
            <div v-if="getSelectedCar.youtubeLink !== ''" class="col-md-6 col-lg-12">
              <div class="card mb-4 box-shadow">
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe class="embed-responsive-item" :src="getSelectedCar.youtubeLink" allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in getSelectedCar.Images" :key="index" class="col-md-6 col-lg-6 col-xl-12">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" :src="imageBaseURL + 'img/cars/' + getSelectedCar.refnum + '/' + (item ? item.name : 'car01.jpg') " :alt="'Fantastico Motors Birmingham 0121-abc-def-xyzz ' + getSelectedCar.make + ' ' + getSelectedCar.model + ' £' + getSelectedCar.price">
                <small class="image-text-below align-self-end text-muted">Fantastico Motors &copy; 2020</small>
              </div>
            </div>
          </div>

        </div>
      </div>

    </main>
    <main v-else-if="car" role="main">

      <section class="jumbotron text-center">
        <div class="container">
          <!-- {{baseURL}} -->
          <img :src="imageBaseURL +  'img/cars/' + car.refnum + '/car01.jpg'" :alt="car.make + ' ' + car.model + ' £' + car.price" class="img img-thumbnail">
          <h5 :v-if="car.name" class="jumbotron-heading pt-3">{{ car.name }}</h5>
          <p class="text-muted" v-html="car.smalldesc"></p>
          <!-- <h6 v-html="car.extra"></h6> -->
          <!-- <h2 class="text-right">£ {{car.price}}</h2> -->
              <table class="table table-sm table-striped pt-2">
                <!-- <thead>
                  <tr>
                    <th scope="col">First</th>
                    <th scope="col">Last</th>
                    <th scope="col">Handle</th>
                  </tr>
                </thead> -->
                <tbody>
                  <tr>
                    <td>Make</td>
                    <td>{{car.make}}</td>
                  </tr>
                  <tr>
                    <td>Model</td>
                    <td>{{car.model}}</td>
                  </tr>
                  <tr>
                    <td>Year</td>
                    <td>{{car.year}}</td>
                  </tr>
                  <tr>
                    <td>Mileage</td>
                    <td>{{car.mileage}}</td>
                  </tr>
                  <!-- <tr>
                    <td>Price</td>
                    <td v-if="car.soldStaus">£ {{car.price}} <div v-if="car.soldStaus" style="background-color:red;color:white;">SOLD</div> </td>
                  </tr> -->
                  <tr v-if="car.soldStaus">
                    <td style="background-color:red;color:white;">SOLD</td>
                    <td style="background-color:red;color:white;"><del>£ {{car.price}} </del></td>
                  </tr>
                  <tr v-else>
                    <td>Price</td>
                    <td v-if="car.price">£ {{car.price}} </td>
                  </tr>
                  <tr>
                    <td colspan="2" class="text-left pt-4"><h5>Description</h5>
                    <div class="text-left" v-html="car.largedesc"></div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="car.extra !== ''" class="card">
                <h5 class="text-left p-3" >Notes</h5 >
                <div class="text-left pl-3 pb-2" v-html="car.extra"></div>
              </div>
          <!-- <p>
            <a href="#" class="btn btn-primary my-2">Main call to action</a>
            <a href="#" class="btn btn-secondary my-2">Secondary action</a>
          </p> -->
        </div>
      </section>

      <div class="album py-5 bg-light">
        <div class="container">
          <!-- <div v-for="(item, index) in carImages" :key="index">
            {{ item.name }}
          </div> -->

          <div v-if="car" class="row">
            <div v-if="car.youtubeLink !== ''" class="col-md-6 col-lg-12">
              <div class="card mb-4 box-shadow">
                <div class="embed-responsive embed-responsive-16by9">
                  <iframe class="embed-responsive-item" :src="car.youtubeLink" allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in car.Images" :key="index" class="col-md-6 col-lg-6 col-xl-12">
              <div class="card mb-4 box-shadow">
                <img class="card-img-top" :src="imageBaseURL + 'img/cars/' + car.refnum + '/' + (item ? item.name : 'car01.jpg') " :alt="'Fantastico Motors Birmingham 0121-abc-def-xyzz ' + car.make + ' ' + car.model + ' £' + car.price">
                <small class="image-text-below align-self-end text-muted">Fantastico Motors &copy; 2020</small>
              </div>
            </div>
          </div>

        </div>
      </div>

    </main>

    <footer class="text-muted">
      <div class="container">
        <p class="float-right">
          <a href="#">Back to top</a>
        </p>
      </div>
    </footer>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'HelloWorld',
  data: function () {
    return {
      car: {},
      carImages: {},
      cars: []
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters(['getSelectedCar', 'getSelectedCarImages', 'isLoading', 'getError'])
  },
  async mounted () {
    console.log('Car page mounted')
    console.log('Route params:', this.$route.params.id)
    
    // Fetch car from API by refnum
    await this.$store.dispatch('fetchCarByRefnum', this.$route.params.id)
    
    // If car is loaded from store, update local data
    if (this.getSelectedCar) {
      this.car = this.getSelectedCar
      console.log('Car loaded:', this.car)
    }
  }
}
</script>

<style scoped>
small.image-text-below {
    position: absolute;
    bottom: 0px;
    right: 5px;
}

.iframe-container{
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}
.iframe-container iframe{
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
